import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
  drawerContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2)
  },
  daysGroup: {
    border: "1px solid #e0e0e0",
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1, 1.5)
  },
  footerButtons: {
    marginTop: theme.spacing(1),
    display: "flex",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  }
}));
